import React from 'react'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import Img from 'gatsby-image'
import './Navigation.css'

export default class Navigation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      collapsed: true,
    }
  }

  toggleNavbar = e => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  render() {
    const navItemsArray = [
      {
        text: 'Vote!',
        link: '/vote',
      },
      {
        text: 'Events',
        link: this.props.siteMetadata.eventUrl,
        targetBlank: '_blank',
      },
      {
        text: 'Stories',
        link: '/stories',
      },
      {
        text: 'News',
        link: '/news',
      },
      {
        text: 'Bond 101',
        link: `/bond101`,
      },
      {
        text: 'Donate!',
        link: this.props.siteMetadata.donateUrl,
        className: 'btn btn-success ml-2',
        style: { color: 'white' },
        targetBlank: '_blank',
      },
    ]

    const GlobalNav = (
      <Nav navbar style={{ marginLeft: 'auto' }}>
        {navItemsArray.map((navitem, i) => (
          <NavItem key={i}>
            <NavLink
              href={navitem.link}
              className={navitem.className}
              style={navitem.style}
              target={navitem.targetBlank}
            >
              {navitem.text}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    )

    return (
      <div className={`Navigation d-flex flex-column flex-md-row`}>
        <Navbar
          color="faded"
          expand="lg"
          light
          fixed="top"
          className="Navigation__navbar"
        >
          <a href="/">
            <Img
              title="Keep Austin Affordable"
              alt="Keep Austin Affordable"
              sizes={this.props.headerImage.sizes}
              className="Navigation__brand"
            />
          </a>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse isOpen={!this.state.collapsed} navbar>
            {GlobalNav}
          </Collapse>
        </Navbar>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js